export const agent = 'manager';
export const version = '0.1.001';
export const stage = 'dev';
export const wlc = 'https://tau.digitender.ru:5100';
